// extracted by css-extract-rspack-plugin
export default {"header":"browse-module__header___BJplp"};